import { render, staticRenderFns } from "./Gameplay.vue?vue&type=template&id=0a05df8c&"
import script from "./Gameplay.vue?vue&type=script&lang=js&"
export * from "./Gameplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports